import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'

type Props = {
  showAlertModal: boolean
  handleCloseAlert: any
}

const AlertContent: FC<Props> = ({showAlertModal, handleCloseAlert}) => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    setShowModal(showAlertModal)
  }, [showAlertModal])

  const handleClose = () => {
    handleCloseAlert(false)
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10 mt-8'>
        <div className='text-center'>
          <img
            src={require('../../assets/img/limited-access.gif')}
            alt='PANA'
            className='img-fluid'
            style={{height: 'auto', width: '30%'}}
          />
        </div>

        <p className='h6 text-center mt-15'>Akses terbatas</p>

        <p>Status beasiswa Anda masih awardee yang belum mendapatkan akses pada portal Talenta</p>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={handleClose}
        >
          Ok
        </button>
      </div>
    </Modal>
  )
}

const AlertModal: FC<Props> = ({showAlertModal, handleCloseAlert}) => {
  return <AlertContent showAlertModal={showAlertModal} handleCloseAlert={handleCloseAlert} />
}

export default AlertModal
